import React from "react";
import styled from "styled-components";
import { FaChartBar } from "react-icons/fa";

/** The one shared header used by every web report. */
export default function ReportPageHeader({ title, subtitle, stats = [], actions }) {
  return <Header>
    <TitleArea>
      <Eyebrow><FaChartBar /> Bill Sarthi Reports</Eyebrow>
      <h1>{title}</h1>
      {subtitle ? <p>{subtitle}</p> : null}
      {stats.length ? <Stats>{stats.map((stat) => <Stat key={stat.label}><small>{stat.label}</small><strong>{stat.value}</strong></Stat>)}</Stats> : null}
    </TitleArea>
    {actions ? <Actions>{actions}</Actions> : null}
  </Header>;
}

const Header=styled.section`
  display:flex;justify-content:space-between;align-items:flex-start;gap:22px;flex-wrap:wrap;
  margin-bottom:16px;padding:26px 28px;border-radius:22px;color:#fff;
  background:linear-gradient(135deg,#075f9e 0%,#0786c5 62%,#0a9ace 100%);
  box-shadow:0 14px 30px rgba(1,91,154,.17);
  @media(max-width:650px){padding:22px 18px;gap:16px;}
`;
const TitleArea=styled.div`min-width:0;h1{margin:5px 0 6px;font-size:clamp(1.45rem,2.4vw,2rem);line-height:1.15}p{margin:0;color:#dff3ff;line-height:1.45}`;
const Eyebrow=styled.div`display:inline-flex;align-items:center;gap:7px;color:#beeaff;font-size:.7rem;font-weight:900;letter-spacing:.1em;text-transform:uppercase`;
const Stats=styled.div`display:flex;gap:8px;flex-wrap:wrap;margin-top:15px`;
const Stat=styled.div`min-width:74px;padding:8px 11px;border:1px solid rgba(255,255,255,.24);border-radius:11px;background:rgba(255,255,255,.14);small,strong{display:block}small{color:#d7f1ff;font-size:.66rem;font-weight:700}strong{margin-top:2px;font-size:.91rem}`;
const Actions=styled.div`display:flex;align-items:center;justify-content:flex-end;gap:8px;flex-wrap:wrap;@media(max-width:650px){width:100%;justify-content:flex-start;}`;
